/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Dropdown} from "react-bootstrap";
import {Glyphicon} from "../../Common/GlyphIcon";
import {StreamBankLink} from "../../Common/StreamBankLink";
import React from "react";
import {service as ConservationActionTypeService} from "../../../Services/ConservationActionTypeService";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {usePatchContext} from "../../../Hooks/RouteHooks";
import {useSafeState} from "../../../Hooks/useSafeState";
import {useValidConservationActionTypes} from "../../../Hooks/useValidConservationActionTypes";

export const AddConservationActionDropdown = (props) => {
    
    usePrimeCache([ConservationActionTypeService]);
    const patchContext = usePatchContext();
    
    const validConservationActionTypes = useValidConservationActionTypes();
    
    if(!validConservationActionTypes?.length) {
        return null;
    }
    
    return <Dropdown>
        <Dropdown.Toggle variant="link">
            <Glyphicon glyph="plus-sign">Add Conservation Action</Glyphicon>
        </Dropdown.Toggle>
        <Dropdown.Menu>
            {
                validConservationActionTypes.map((x) =>
                    <Dropdown.Item key={x.conservationActionTypeId} eventKey={x.conservationActionTypeId}
                                   as={StreamBankLink} Context={
                        patchContext({ conservationAction: "new" })
                    } Tool="summary" ToolParam={{ type: x.conservationActionTypeId }} AllowNew={true}>
                        Add {x.name}
                    </Dropdown.Item>
                )
            }
        </Dropdown.Menu>
    </Dropdown>;
};
